(function() {
  'use strict';

  // ── Office hours gate ─────────────────────────────────────────────────────
  // Hide chatbot Mon–Fri 08:45–16:45 Europe/London (handles GMT/BST automatically).
  (function() {
    try {
      var now  = new Date();
      var fmt  = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
      });
      var parts = fmt.formatToParts(now).reduce(function(acc, p) {
        acc[p.type] = p.value; return acc;
      }, {});
      var days = { Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6, Sun:0 };
      var day  = days[parts.weekday] || 0;
      var mins = parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10);
      var inOfficeHours = day >= 1 && day <= 5            // Mon–Fri
                       && mins >= (8 * 60 + 45)           // 08:45
                       && mins <  (16 * 60 + 45);         // 16:45
      if (inOfficeHours) { window.__sbChatHidden = true; }
    } catch(e) {}
  })();
  if (window.__sbChatHidden) return;

  var API         = 'https://email.silverbackgymwear.com/api/customer-chat';
  var ESCALATE    = 'https://email.silverbackgymwear.com/api/customer-chat-escalate';
  var EMAIL_API   = 'https://email.silverbackgymwear.com/api/customer-chat-email';
  var MODE_API    = 'https://email.silverbackgymwear.com/api/chat-mode';
  var IMG         = 'https://email.silverbackgymwear.com/talent/public/img/';
  var STORE_KEY   = 'sb_chat_v21';

  // ── Language detection ────────────────────────────────────────────────────
  var isFr = (
    (window.Shopify && window.Shopify.locale && window.Shopify.locale.startsWith('fr')) ||
    /^\/fr(\/|$)/.test(window.location.pathname)
  );
  var lang = isFr ? 'fr' : 'en';

  var WELCOME_MSG = isFr
    ? 'Salut 👊 Comment puis-je vous aider ? Posez vos questions sur les tailles, la livraison, les retours ou votre commande.'
    : 'Hey 👊 What can I help you with? Ask about sizing, delivery, returns, or your order.';

  var history     = [{role:"assistant",content: WELCOME_MSG}];
  var escalated   = false;
  var emailed     = false;
  var firstMsg    = '';
  var sessionId   = 'sb_' + Date.now() + '_' + Math.random().toString(36).slice(2,7);
  var humanMode   = false;

  // Restore session from sessionStorage
  try {
    var saved = sessionStorage.getItem(STORE_KEY);
    if (saved) {
      var s = JSON.parse(saved);
      if (s.history && s.history.length) history = s.history;
      if (s.firstMsg) firstMsg = s.firstMsg;
      if (s.sessionId) sessionId = s.sessionId;
      if (s.escalated) escalated = s.escalated;
      if (s.emailed) emailed = s.emailed;
    }
  } catch(_) {}

  function saveState() {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({ history, firstMsg, sessionId, escalated, emailed }));
    } catch(_) {}
  }

  // ── Office hours ──────────────────────────────────────────────────────────
  function isOfficeHours() {
    var now = new Date();
    var day = now.getUTCDay(), hour = now.getUTCHours();
    return day >= 1 && day <= 5 && hour >= 9 && hour < 17;
  }

  // ── Styles ────────────────────────────────────────────────────────────────
  var style = document.createElement('style');
  style.textContent = `
    /* ── Bubble ── */
    #sb-chat-bubble {
      position: fixed; bottom: 24px; left: 24px; z-index: 99999;
      width: 60px; height: 60px; border-radius: 50%;
      background: #000; border: 2px solid #222;
      cursor: pointer; display: flex; align-items: center; justify-content: center;
      box-shadow: 0 4px 24px rgba(0,0,0,0.15);
      animation: sbFloat 4s ease-in-out infinite;
    }
    #sb-chat-bubble img { width: 40px; height: 40px; object-fit: contain; }
    @keyframes sbFloat {
      0%,100% { transform: translateY(0px); }
      50%      { transform: translateY(-5px); }
    }

    /* Attention ring — fires once after 4s */
    #sb-chat-bubble::before, #sb-chat-bubble::after {
      content: ''; position: absolute; inset: -2px; border-radius: 50%;
      border: 2px solid rgba(255,255,255,0.3);
      opacity: 0; pointer-events: none;
    }
    #sb-chat-bubble.sb-ring::before {
      animation: sbRing 1.2s ease-out 0s 1;
    }
    #sb-chat-bubble.sb-ring::after {
      animation: sbRing 1.2s ease-out 0.3s 1;
    }
    @keyframes sbRing {
      0%   { transform: scale(1); opacity: 0.7; }
      100% { transform: scale(2.2); opacity: 0; }
    }

    /* Unread badge */
    #sb-badge {
      position: absolute; top: -3px; right: -3px;
      width: 18px; height: 18px; border-radius: 50%;
      background: #e53935; color: #000; font-size: 10px; font-weight: 700;
      display: flex; align-items: center; justify-content: center;
      border: 2px solid #000;
      animation: sbBadgePop 0.3s cubic-bezier(0.34,1.56,0.64,1);
    }
    @keyframes sbBadgePop {
      from { transform: scale(0); }
      to   { transform: scale(1); }
    }

    /* ── Chat window ── */
    #sb-chat-window {
      position: fixed; bottom: 104px; left: 24px; z-index: 99998;
      width: 430px; max-width: calc(100vw - 32px);
      height: 640px; max-height: calc(100vh - 120px);
      background: #f5f5f5; border: 1px solid #e0e0e0; border-radius: 14px;
      display: flex; flex-direction: column; overflow: hidden;
      box-shadow: 0 16px 60px rgba(0,0,0,0.15), 0 0 0 1px rgba(255,255,255,0.04);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      transition: opacity 0.2s ease, transform 0.2s ease;
      transform: translateY(0);
      box-sizing: border-box;
    }
    #sb-chat-window * { box-sizing: border-box; }
    #sb-chat-window.sb-hidden {
      opacity: 0; pointer-events: none;
      transform: translateY(10px);
    }

    /* ── Header ── */
    #sb-chat-header {
      background: #fff; padding: 10px 14px 8px;
      border-bottom: 1px solid #1a1a1a; flex-shrink: 0;
      position: relative; overflow: hidden;
    }
    #sb-chat-header::after {
      content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%;
      background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.04) 50%, transparent 100%);
      pointer-events: none; transform: translateX(-100%);
    }
    #sb-chat-window:not(.sb-hidden) #sb-chat-header::after {
      animation: sbShimmer 4s ease-in-out infinite;
    }
    @keyframes sbShimmer { 0%{transform:translateX(-100%)} 50%,100%{transform:translateX(100%)} }
    .sb-hd-row    { display:flex; align-items:center; gap:10px; }
    .sb-hd-icon   { width:28px; height:28px; object-fit:contain; flex-shrink:0; }
    .sb-hd-status { display:flex; align-items:center; gap:10px; flex:1; min-width:0; }
    .sb-dot {
      width: 16px; height: 16px; border-radius: 50%; flex-shrink: 0;
    }
    .sb-dot-human  { background: #4caf50; }
    .sb-dot-ai     { background: #2979ff; }
    #sb-chat-window:not(.sb-hidden) .sb-dot-human { animation: sbPulseGreen 2s infinite; }
    #sb-chat-window:not(.sb-hidden) .sb-dot-ai { animation: sbPulseBlue 3s infinite; }
    .sb-dot-offline{ background: #333; }
    @keyframes sbPulseGreen {
      0%,100% { box-shadow: 0 0 0 0 rgba(76,175,80,0.6); }
      50%     { box-shadow: 0 0 0 12px rgba(76,175,80,0); }
    }
    @keyframes sbPulseBlue {
      0%,100% { box-shadow: 0 0 0 0 rgba(41,121,255,0.5); }
      50%     { box-shadow: 0 0 0 10px rgba(41,121,255,0); }
    }
    .sb-status-text { font-size: 20px; color: #444; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    #sb-chat-close {
      background: none; border: none; color: #000; font-size: 28px; font-weight: 900;
      cursor: pointer; padding: 4px; line-height: 1;
      transition: color 0.15s, transform 0.15s;
      position: relative; z-index: 1; flex-shrink: 0;
    }
    #sb-chat-close:hover { color: #000; transform: rotate(90deg); }
    #sb-header-quote { display: none; }
    #sb-quote-text   { font-size: 9px; color: #444; font-style: italic; white-space: nowrap; }
    #sb-quote-cursor { display:inline-block; width:1px; height:9px; background:#777; margin-left:1px; vertical-align:middle; }
    #sb-chat-window:not(.sb-hidden) #sb-quote-cursor { animation: sbBlink 0.7s step-end infinite; }
    @keyframes sbBlink { 0%,100%{opacity:1} 50%{opacity:0} }
    #sb-quote-author { font-size: 8px; color: #444; margin-left: 4px; opacity: 0; transition: opacity 0.5s; white-space: nowrap; }

    /* ── Messages ── */
    #sb-chat-messages {
      flex: 1; overflow-y: auto; padding: 16px; display: flex;
      flex-direction: column; gap: 10px;
    }
    #sb-chat-messages::-webkit-scrollbar { width: 3px; }
    #sb-chat-messages::-webkit-scrollbar-track { background: transparent; }
    #sb-chat-messages::-webkit-scrollbar-thumb { background: #e0e0e0; border-radius: 2px; }
    
    /* Product cards container scrollbar */
    .sb-products-wrap::-webkit-scrollbar { width: 4px; }
    .sb-products-wrap::-webkit-scrollbar-track { background: transparent; }
    .sb-products-wrap::-webkit-scrollbar-thumb { background: #ccc; border-radius: 2px; }


    .sb-msg {
      max-width: 85%; font-size: 14px; line-height: 1.5;
      padding: 10px 13px; border-radius: 12px; word-wrap: break-word;
      animation: sbMsgIn 0.25s cubic-bezier(0.34,1.3,0.64,1) both;
    }
    @keyframes sbMsgIn {
      from { opacity: 0; transform: translateY(10px) scale(0.97); }
      to   { opacity: 1; transform: translateY(0) scale(1); }
    }
    .sb-msg.sb-user {
      background: #fff; color: #000; align-self: flex-end;
      border-bottom-right-radius: 3px;
    }
    .sb-msg.sb-bot {
      background: #e8e8e8; color: #333; align-self: flex-start;
      border-bottom-left-radius: 3px; border: 1px solid #e0e0e0;
    }
    .sb-msg.sb-system {
      background: transparent; color: #444; font-size: 11px;
      text-align: center; align-self: center; max-width: 100%;
      padding: 2px 0; border: none;
    }

    /* Typing dots */
    .sb-typing-wrap {
      display: flex !important; gap: 5px; align-items: center !important;
      background: #e8e8e8; border: 1px solid #e0e0e0;
      border-bottom-left-radius: 3px; border-radius: 12px;
      padding: 12px 14px; align-self: flex-start;
      animation: sbMsgIn 0.2s ease both;
      visibility: visible !important; opacity: 1 !important;
    }
    .sb-typing-dot {
      width: 7px; height: 7px; border-radius: 50% !important; background: #666 !important;
      animation: sbBounce 1.2s ease-in-out infinite !important;
      display: block !important; opacity: 1 !important;
    }
    .sb-typing-dot:nth-child(2) { animation-delay: 0.15s !important; }
    .sb-typing-dot:nth-child(3) { animation-delay: 0.3s !important; }
    @keyframes sbBounce {
      0%,60%,100% { transform: translateY(0); background: #666; }
      30% { transform: translateY(-7px); background: #bbb; }
    }

    /* ── Action bars ── */
    #sb-escalate-bar {
      padding: 10px 12px; border-top: 1px solid #e5e5e5;
      flex-shrink: 0; background: #fafafa; display: none;
    }
    #sb-escalate-btn {
      width: 100%; background: transparent; border: 1px solid #ccc;
      color: #444; border-radius: 8px; padding: 9px 12px; font-size: 13px;
      cursor: pointer; transition: all 0.2s; font-family: inherit; letter-spacing: 0.3px;
    }
    #sb-escalate-btn:hover { border-color: #000; color: #000; background: #f0f0f0; transform: translateY(-1px); }
    #sb-escalate-btn:disabled { opacity: 0.4; cursor: default; transform: none; }

    #sb-email-bar {
      display: none; position: absolute; bottom: 90px; left: 8px; right: 8px; z-index: 10;
      padding: 14px 14px 12px; border-radius: 12px;
      background: #e8f0ff; border: 1px solid #2a2a3e;
      box-shadow: 0 -4px 32px rgba(0,0,0,0.1), 0 4px 24px rgba(0,0,0,0.4);
      animation: sbEmailSlide 0.22s cubic-bezier(0.34,1.56,0.64,1);
    }
    @keyframes sbEmailSlide { from { opacity:0; transform: translateY(14px); } to { opacity:1; transform: translateY(0); } }
    #sb-email-close {
      position: absolute; top: 8px; right: 10px;
      background: none; border: none; color: #444; font-size: 18px; font-weight: 700;
      cursor: pointer; padding: 2px 6px; line-height: 1; transition: color 0.15s;
    }
    #sb-email-close:hover { color: #000; }
    #sb-email-bar p { margin: 0 0 8px; font-size: 12px; color: #444; font-weight: 600; padding-right: 24px; }
    .sb-email-row { display: flex; gap: 6px; margin-bottom: 8px; }
    #sb-email-name, #sb-email-addr {
      flex: 1; background: #f0f4ff; border: 1px solid #c8d4f0; color: #333;
      border-radius: 8px; padding: 8px 10px; font-size: 13px;
      outline: none; font-family: inherit; transition: border-color 0.15s;
    }
    #sb-email-name:focus, #sb-email-addr:focus { border-color: #555; }
    #sb-email-name::placeholder, #sb-email-addr::placeholder { color: #555; }
    #sb-email-submit {
      width: 100%; background: #fff; color: #000; border: none;
      border-radius: 8px; padding: 9px; font-size: 13px; font-weight: 700;
      cursor: pointer; font-family: inherit; transition: background 0.15s;
    }
    #sb-email-submit:hover { background: #eee; }
    #sb-email-submit:disabled { background: #222; color: #555; cursor: default; }

    /* ── Input footer ── */
    #sb-chat-footer {
      padding: 10px 12px; border-top: 1px solid #e5e5e5;
      display: flex; align-items: center; gap: 8px; flex-shrink: 0; background: #f5f5f5;
    }
    #sb-chat-input {
      flex: 1; background: #f0f0f0; border: 1px solid #ddd; color: #333;
      border-radius: 10px; padding: 10px 12px; font-size: 14px;
      outline: none; resize: none; font-family: inherit;
      line-height: 1.4; max-height: 100px; -webkit-appearance: none; -moz-appearance: none; appearance: none; transition: border-color 0.15s;
    }
    #sb-chat-input:focus { border-color: #bbb; outline: none; box-shadow: none; }
    #sb-chat-input::placeholder { color: #444; }
    #sb-chat-send {
      background: #fff; color: #000; border: none; border-radius: 10px;
      width: 40px; height: 40px; cursor: pointer; display: flex;
      align-items: center; justify-content: center; flex-shrink: 0;
      transition: background 0.15s, transform 0.15s;
    }
    #sb-chat-send:hover { background: #ddd; transform: scale(1.05); }
    #sb-chat-send:active { background: #ccc; transform: scale(0.97); }
    #sb-chat-send:disabled { background: #e8e8e8; color: #bbb; cursor: default; transform: none; }
    #sb-chat-send svg { width: 17px; height: 17px; fill: currentColor; }

    #sb-chat-branding {
      display: flex; align-items: center; justify-content: space-between;
      padding: 8px 14px; font-size: 12px; color: #444;
      letter-spacing: 1.5px; flex-shrink: 0; text-transform: uppercase;
    }
    #sb-contact-link {
      font-size: 12px; color: #000; letter-spacing: 1px; text-transform: uppercase;
      background: none; border: none; cursor: pointer; font-family: inherit;
      padding: 0; transition: color 0.15s; font-weight: 700;
    }
    #sb-contact-link:hover { color: #666; }

    /* ── Mobile Responsive ── */
    @media (max-width: 480px) {
      #sb-chat-window {
        inset: 0;
        width: 100vw;
        height: 100dvh;
        max-width: 100vw;
        max-height: 100dvh;
        border-radius: 0;
        border: none;
        transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        transform: translateY(0);
        padding-top: env(safe-area-inset-top);
        padding-bottom: 0;
      }
      #sb-chat-window.sb-hidden {
        transform: translateY(100%);
        opacity: 1;
      }
      /* keep the input and bottom links clear of the home bar */
      #sb-chat-footer { padding-bottom: calc(10px + env(safe-area-inset-bottom)); }
      #sb-chat-branding { padding-bottom: calc(10px + env(safe-area-inset-bottom)); }

      #sb-chat-bubble { bottom: 15px; left: 15px; }

      .sb-email-row { flex-direction: column; }
      #sb-email-bar { bottom: calc(120px + env(safe-area-inset-bottom)); left: 10px; right: 10px; }

      #sb-chat-branding {
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
      }
      #sb-chat-branding span, #sb-contact-link {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      #sb-contact-link { text-align: left; }

      /* slightly tighter typography on small screens */
      #sb-chat-branding, #sb-contact-link { font-size: 11px !important; letter-spacing: 1px; }

      /* Tidio-style mobile layout */
      #sb-chat-header { padding: 16px 16px 14px; }
      #sb-header-quote { display:none; }
      #sb-chat-messages { padding: 14px 14px 4px; }

      /* Bottom composer becomes a card */
      #sb-chat-footer {
        margin: 0 12px 10px;
        border: 1px solid #e0e0e0;
        border-radius: 16px;
        padding: 10px 10px;
        background: #fff;
        box-shadow: 0 4px 20px rgba(0,0,0,0.08);
      }
      #sb-chat-input { font-size: 16px; padding: 12px 12px; border: 1px solid #ddd; -webkit-appearance: none; -moz-appearance: none; appearance: none; }
      #sb-chat-input:focus { border-color: #bbb; outline: none; box-shadow: none; }
      #sb-chat-send { width: 48px; height: 48px; border-radius: 14px; }

      /* give breathing room below composer */
      #sb-chat-branding { padding: 8px 14px calc(12px + env(safe-area-inset-bottom)); }
    }
  `;
  document.head.appendChild(style);

  // ── HTML ──────────────────────────────────────────────────────────────────
  var bubble = document.createElement('div');
  bubble.id = 'sb-chat-bubble';
  bubble.setAttribute('aria-label', 'Chat with Silverback support');
  bubble.innerHTML = `<img src="${IMG}icon-white.png" alt="Silverback" />`;

  var win = document.createElement('div');
  win.id = 'sb-chat-window';
  win.className = 'sb-hidden';
  win.innerHTML = `
    <div id="sb-chat-header">
      <div class="sb-hd-row">
        <img src="${IMG}icon-white.png" alt="Silverback" class="sb-hd-icon" />
        <div class="sb-hd-status">
          <div class="sb-dot sb-dot-ai" id="sb-status-dot"></div>
          <span class="sb-status-text" id="sb-status-text">Loading...</span>
        </div>
        <button id="sb-chat-close" aria-label="Close chat">×</button>
      </div>
      <div id="sb-header-quote">
        <span id="sb-quote-text"></span><span id="sb-quote-cursor">|</span>
        <span id="sb-quote-author"></span>
      </div>
    </div>
    <div id="sb-chat-messages">
      <div class="sb-msg sb-bot">${WELCOME_MSG}</div>
    </div>
    <div id="sb-escalate-bar">
      <button id="sb-escalate-btn">${isFr ? '👋 Parler à un humain' : '👋 Talk to a human'}</button>
    </div>
    <div id="sb-email-bar">
      <button id="sb-email-close" aria-label="Close">✕</button>
      <p>${isFr ? 'Vous souhaitez une réponse humaine ?' : 'Want a human to follow up?'}</p>
      <div class="sb-email-row">
        <input id="sb-email-name" type="text" placeholder="Name" autocomplete="name" />
        <input id="sb-email-addr" type="email" placeholder="Email" autocomplete="email" />
      </div>
      <button id="sb-email-submit">Send to the team</button>
    </div>
    <div id="sb-chat-footer">
      <textarea id="sb-chat-input" placeholder="Ask anything..." rows="1"></textarea>
      <button id="sb-chat-send" aria-label="Send">
        <svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
      </button>
    </div>
    <div id="sb-chat-branding">
      <span>Silverback</span>
      <button id="sb-contact-link">Talk to the team →</button>
    </div>
  `;

  document.body.appendChild(bubble);
  document.body.appendChild(win);

  // Apply French UI strings if needed
  if (isFr) {
    var inp = document.getElementById('sb-chat-input');
    if (inp) inp.placeholder = 'Posez votre question...';
    var emailClose = document.getElementById('sb-email-close');
    var emailP = win.querySelector('#sb-email-panel p');
    if (emailP) emailP.textContent = 'Vous souhaitez une réponse humaine ?';
    var emailSubmit = document.getElementById('sb-email-submit');
    if (emailSubmit) emailSubmit.textContent = 'Envoyer à l\'équipe';
    var emailName = document.getElementById('sb-email-name');
    if (emailName) emailName.placeholder = 'Nom';
    var emailAddr = document.getElementById('sb-email-addr');
    if (emailAddr) emailAddr.placeholder = 'E-mail';
  }

  // Restore saved chat session if returning from another page
  (function restoreSession() {
    try {
      if (history.length > 1) {
        // Clear default message and re-render full history
        var msgBox = document.getElementById('sb-chat-messages');
        if (msgBox) {
          msgBox.innerHTML = '';
          history.forEach(function(m) {
            var role = m.role === 'user' ? 'user' : 'bot';
            addMessage(role, m.content);
          });
        }
        // Restore UI state
        if (emailed) {
          document.getElementById('sb-email-bar').style.display = 'none';
        }
        if (escalated) {
          document.getElementById('sb-escalate-bar').style.display = 'none';
        }
      }
    } catch(_) {}
  })();

  // ── Mode & status ─────────────────────────────────────────────────────────
  function updateStatusIndicator(forceAI, serverDown) {
    var dot  = document.getElementById('sb-status-dot');
    var text = document.getElementById('sb-status-text');
    if (!dot || !text) return;
    humanMode = !forceAI && isOfficeHours();
    if (serverDown) {
      dot.className = 'sb-dot sb-dot-offline';
      text.textContent = isFr ? 'Actuellement indisponible' : 'Currently unavailable';
    } else if (humanMode) {
      dot.className = 'sb-dot sb-dot-human';
      text.textContent = isFr ? 'Équipe en ligne' : 'Team online';
    } else {
      dot.className = 'sb-dot sb-dot-ai';
      text.textContent = isFr
        ? (isOfficeHours() ? 'Support IA' : 'Horaires Lun–Ven 9h–17h GMT')
        : (isOfficeHours() ? 'AI support' : 'Office Hours Mon–Fri 9–5 GMT');
    }
  }

  async function fetchMode() {
    try {
      var r = await fetch(MODE_API);
      var d = await r.json();
      updateStatusIndicator(d.forceAI || false, false);
    } catch(_) { updateStatusIndicator(false, true); }
  }

  // ── Quotes ───────────────────────────────────────────────────────────────
  var QUOTES_EN = [
    {q:'The last three or four reps is what makes the muscle grow.',a:'Arnold Schwarzenegger'},
    {q:'Strength does not come from the body. It comes from the will.',a:'Mahatma Gandhi'},
    {q:'Champions aren\'t made in gyms. Champions are made from something inside.',a:'Muhammad Ali'},
    {q:'If you want something you\'ve never had, you must do something you\'ve never done.',a:''},
    {q:'The pain you feel today will be the strength you feel tomorrow.',a:''},
    {q:'Push yourself, because no one else is going to do it for you.',a:''},
    {q:'The body achieves what the mind believes.',a:''},
    {q:'Train insane or remain the same.',a:''},
    {q:'Be stronger than your strongest excuse.',a:''},
    {q:'Fall down seven times, get up eight.',a:'Japanese Proverb'},
    {q:'It never gets easier, you just get stronger.',a:''},
    {q:'No pain, no gain. Shut up and train.',a:''},
    {q:'Once you see results it becomes an addiction.',a:''},
    {q:'Wake up. Work out. Look hot. Kick ass.',a:''},
    {q:'Your only limit is you.',a:''},
    {q:'Pain is weakness leaving the body.',a:''},
    {q:'Dead last finish is greater than did not finish.',a:''},
    {q:'Sweat is just fat crying.',a:''},
    {q:'Go hard or go home.',a:''},
    {q:'Success usually comes to those too busy to be looking for it.',a:'Thoreau'}
  ];
  var QUOTES_FR = [
    {q:'Les trois ou quatre dernières reps, c\'est ce qui fait grandir le muscle.',a:'Arnold Schwarzenegger'},
    {q:'La force ne vient pas du corps. Elle vient de la volonté.',a:'Mahatma Gandhi'},
    {q:'Les champions ne sont pas faits dans les salles de sport. Ils viennent de l\'intérieur.',a:'Muhammad Ali'},
    {q:'Si tu veux quelque chose que tu n\'as jamais eu, fais quelque chose que tu n\'as jamais fait.',a:''},
    {q:'La douleur d\'aujourd\'hui, c\'est la force de demain.',a:''},
    {q:'Pousse-toi, parce que personne ne le fera à ta place.',a:''},
    {q:'Le corps accomplit ce que l\'esprit croit.',a:''},
    {q:'Entraîne-toi à fond ou reste ordinaire.',a:''},
    {q:'Sois plus fort que ta meilleure excuse.',a:''},
    {q:'Tomber sept fois, se relever huit.',a:'Proverbe japonais'},
    {q:'Ce n\'est jamais plus facile, tu deviens juste plus fort.',a:''},
    {q:'Pas de douleur, pas de gain.',a:''},
    {q:'Une fois que tu vois les résultats, ça devient une addiction.',a:''},
    {q:'Lève-toi. Entraîne-toi. Sois au top.',a:''},
    {q:'Ta seule limite, c\'est toi.',a:''},
    {q:'La douleur, c\'est la faiblesse qui quitte ton corps.',a:''},
    {q:'Finir dernier vaut mieux que ne pas finir.',a:''},
    {q:'La sueur, c\'est la graisse qui pleure.',a:''},
    {q:'À fond ou rentrer à la maison.',a:''},
    {q:'Le succès vient à ceux trop occupés pour le chercher.',a:'Thoreau'}
  ];
  var QUOTES = isFr ? QUOTES_FR : QUOTES_EN;
  var qIdx = 0;
  function typeQuote() {
    var el = document.getElementById('sb-quote-text');
    var auth = document.getElementById('sb-quote-author');
    if (!el || !auth) return;
    var q = QUOTES[qIdx % QUOTES.length];
    var txt = '\u201c' + q.q + '\u201d';
    var i = 0;
    el.textContent = '';
    auth.style.opacity = '0';
    auth.textContent = q.a ? '\u2014 ' + q.a : '';
    (function type() {
      if (i < txt.length) { el.textContent += txt[i++]; setTimeout(type, 26); }
      else {
        if (q.a) setTimeout(function(){ auth.style.opacity='1'; }, 200);
        setTimeout(function(){ qIdx++; typeQuote(); }, 4500);
      }
    })();
  }
  typeQuote();

  // ── Logic ─────────────────────────────────────────────────────────────────
  var open = false;
  var sending = false;
  var msgCount = 0;

  function toggle() {
    open = !open;
    win.classList.toggle('sb-hidden', !open);
    bubble.style.display = open ? 'none' : 'flex';
    var badge = document.getElementById('sb-badge');
    if (badge) badge.remove();
    if (open) {
      fetchMode();
      syncToVisualViewport();
      document.getElementById('sb-chat-input').focus();
    } else {
      clearVisualViewportPin();
    }
  }

  function renderText(text) {
    return text
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/\*\*(.*?)\*\*/g,'<strong>$1</strong>')
      .replace(/\*(.*?)\*/g,'<em>$1</em>')
      .replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g,'<a href="$2" target="_blank" rel="noopener" style="color:#6ab0f5;text-decoration:underline">$1</a>')
      .replace(/(^|[\s])((https?:\/\/[^\s<]+))/g,'$1<a href="$3" target="_blank" rel="noopener" style="color:#6ab0f5;text-decoration:underline">$3</a>')
      .replace(/\n/g,'<br>');
  }
  function addMessage(role, text) {
    var msgs = document.getElementById('sb-chat-messages');
    var el = document.createElement('div');
    el.className = 'sb-msg sb-' + role;
    if (role === 'bot') { el.innerHTML = renderText(text); }
    else { el.textContent = text; }
    msgs.appendChild(el);
    msgs.scrollTop = msgs.scrollHeight;
    return el;
  }

  function addProductCards(products) {
    var msgs = document.getElementById('sb-chat-messages');
    var wrap = document.createElement('div');
    wrap.className = 'sb-products-wrap';
    // Allow scrolling if many products (more than 6)
    var needsScroll = products.length > 6;
    wrap.style.cssText = 'display:flex;flex-direction:column;gap:8px;padding:4px 0;' + 
      (needsScroll ? 'max-height:400px;overflow-y:auto;scrollbar-width:thin;' : '');
    products.forEach(function(p) {
      var card = document.createElement('a');
      card.href = p.url;
      card.target = '_blank';
      card.rel = 'noopener';
      card.style.cssText = 'display:flex;align-items:center;gap:10px;background:#111;border:1px solid #222;border-radius:8px;padding:10px;text-decoration:none;color:inherit;transition:border-color 0.15s;';
      card.onmouseover = function(){ this.style.borderColor='#444'; };
      card.onmouseout = function(){ this.style.borderColor='#222'; };
      var img = p.image ? '<img src="'+p.image+'" style="width:48px;height:48px;object-fit:cover;border-radius:4px;flex-shrink:0;" />' : '<div style="width:48px;height:48px;background:#222;border-radius:4px;flex-shrink:0;"></div>';
      card.innerHTML = img +
        '<div style="flex:1;min-width:0;">' +
          '<div style="font-size:12px;font-weight:700;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">'+p.title+'</div>' +
          (p.price ? '<div style="font-size:11px;color:#888;margin-top:2px;">'+p.price+(p.available===false?' · <span style="color:#c44;">Out of Stock</span>':'')+' </div>' : '') +
        '</div>' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#444" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>';
      wrap.appendChild(card);
    });
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function showTyping() {
    var msgs = document.getElementById('sb-chat-messages');
    var wrap = document.createElement('div');
    wrap.className = 'sb-typing-wrap';
    wrap.id = 'sb-typing';
    wrap.innerHTML = '<div class="sb-typing-dot"></div><div class="sb-typing-dot"></div><div class="sb-typing-dot"></div>';
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function removeTyping() {
    var el = document.getElementById('sb-typing');
    if (el) el.remove();
  }

  async function escalate() {
    if (escalated) return;
    var btn = document.getElementById('sb-escalate-btn');
    btn.disabled = true; btn.textContent = 'Connecting...';
    var transcript = history.map(function(m) {
      return (m.role === 'user' ? 'Customer: ' : 'AI: ') + m.content;
    }).join('\n');
    try {
      await fetch(ESCALATE, {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ sessionId, transcript, history })
      });
      escalated = true;
      saveState();
      document.getElementById('sb-escalate-bar').style.display = 'none';
      addMessage('system', '✓ Team notified — someone will be in touch shortly');
      addMessage('bot', 'I\'ve flagged this for the team 💪 They\'ll follow up soon. Anything else I can help with in the meantime?');
    } catch(e) {
      btn.disabled = false; btn.textContent = '👋 Talk to a human';
      addMessage('system', 'Could not connect — email us at info@silverbackgymwear.com');
    }
  }

  async function submitEmail() {
    if (emailed) return;
    var name  = document.getElementById('sb-email-name').value.trim();
    var email = document.getElementById('sb-email-addr').value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      var inp = document.getElementById('sb-email-addr');
      inp.style.borderColor = '#c00'; inp.focus(); return;
    }
    var btn = document.getElementById('sb-email-submit');
    btn.disabled = true; btn.textContent = 'Sending...';
    try {
      await fetch(EMAIL_API, {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          customerName: name, customerEmail: email, firstMessage: firstMsg,
          transcript: history.map(function(m) {
            return (m.role === 'user' ? (name || 'Customer') : 'Silverback AI') + ': ' + m.content;
          }).join('\n'),
          history
        })
      });
      emailed = true;
      saveState();
      document.getElementById('sb-email-bar').style.display = 'none';
      addMessage('system', '✓ Message sent — we\'ll reply within 1 business day');
      addMessage('bot', 'All sent 💪 You\'ll hear from the team soon. WALK WITH THE STRONG 🦍');
    } catch(e) {
      btn.disabled = false; btn.textContent = 'Send to the team';
      addMessage('system', 'Could not send — email info@silverbackgymwear.com directly');
    }
  }

  var cartContextCache = { ts: 0, value: null };

  function formatMoneyFromCents(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'GBP'
      }).format(amount);
    } catch(_) {
      return amount.toFixed(2) + ' ' + (currency || 'GBP');
    }
  }

  function detectPageType() {
    var path = window.location.pathname || '/';
    if (/^\/cart(\/|$)/.test(path)) return 'cart';
    if (/^\/products\//.test(path)) return 'product';
    if (/^\/collections\//.test(path)) return 'collection';
    if (/^\/pages\//.test(path)) return 'page';
    if (/^\/account(\/|$)/.test(path)) return 'account';
    return path === '/' ? 'home' : 'other';
  }

  function getCurrentProductContext() {
    var match = (window.location.pathname || '').match(/^\/products\/([^/?#]+)/);
    if (!match) return null;
    return {
      handle: match[1],
      title: (document.title || '').split(/\s*[|\u2013\u2014\u2012]\s*/)[0].trim()
    };
  }

  function getSelectedVariantContext() {
    var product = getCurrentProductContext();
    if (!product) return null;

    var variantId = new URLSearchParams(window.location.search).get('variant');
    if (!variantId) {
      var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (idInput && idInput.value) variantId = idInput.value;
    }

    var selectedOptions = [];
    document.querySelectorAll('form[action*="/cart/add"] select').forEach(function(sel) {
      if (sel.value) selectedOptions.push(sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text.trim() : sel.value);
    });
    document.querySelectorAll('form[action*="/cart/add"] input[type="radio"]:checked').forEach(function(radio) {
      var text = radio.value || radio.getAttribute('title') || radio.getAttribute('aria-label');
      if (text) selectedOptions.push(String(text).trim());
    });

    var addBtn = document.querySelector('form[action*="/cart/add"] [type="submit"], button[name="add"]');
    var priceNode = document.querySelector('[data-product-price], .price-item--regular, .price__regular .price-item, .price-item');

    return {
      id: variantId || '',
      title: selectedOptions.join(' / ') || (product.title || ''),
      available: addBtn ? !addBtn.disabled : true,
      priceFormatted: priceNode ? priceNode.textContent.trim().replace(/\s+/g, ' ') : '',
      selectedOptions: selectedOptions
    };
  }

  function getCustomerContext() {
    var pageMeta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page
      ? window.ShopifyAnalytics.meta.page
      : {};
    var customerId = pageMeta.customerId || pageMeta.customer_id || '';
    var bodyClass = document.body ? document.body.className : '';
    var loggedIn = !!customerId || /customer|account/.test(window.location.pathname || '') || /(logged|customer)/i.test(bodyClass);
    return {
      loggedIn: !!loggedIn,
      id: customerId ? String(customerId) : ''
    };
  }

  async function getCartContext() {
    if (Date.now() - cartContextCache.ts < 15000 && cartContextCache.value) return cartContextCache.value;
    try {
      var res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return null;
      var cart = await res.json();
      var currency = cart.currency || ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '');
      var context = {
        itemCount: cart.item_count || 0,
        totalPrice: String((cart.total_price || 0) / 100),
        totalPriceFormatted: formatMoneyFromCents(cart.total_price || 0, currency),
        currency: currency,
        items: (cart.items || []).slice(0, 10).map(function(item) {
          return {
            title: item.product_title || item.title || '',
            variantTitle: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
            quantity: item.quantity || 0,
            productType: item.product_type || '',
            vendor: item.vendor || '',
            url: item.url ? window.location.origin + item.url : '',
            finalLinePrice: String((item.final_line_price || 0) / 100),
            finalLinePriceFormatted: formatMoneyFromCents(item.final_line_price || 0, currency)
          };
        })
      };
      cartContextCache = { ts: Date.now(), value: context };
      return context;
    } catch(_) {
      return null;
    }
  }

  async function getStorefrontContext() {
    var country = (window.Shopify && (window.Shopify.country || window.Shopify.Country)) || '';
    var currency = (window.Shopify && window.Shopify.currency && (window.Shopify.currency.active || window.Shopify.currency.currentCurrency)) || '';
    var locale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || '';
    return {
      pageType: detectPageType(),
      country: country || '',
      currency: currency || '',
      locale: locale || '',
      customer: getCustomerContext(),
      currentProduct: getCurrentProductContext(),
      selectedVariant: getSelectedVariantContext(),
      cart: await getCartContext()
    };
  }

  async function send() {
    if (sending) return;
    var input = document.getElementById('sb-chat-input');
    var text = input.value.trim();
    if (!text) return;
    if (!firstMsg) firstMsg = text;
    input.value = ''; input.style.height = 'auto';
    sending = true;
    document.getElementById('sb-chat-send').disabled = true;
    addMessage('user', text);
    showTyping();
    msgCount++;

    var allText = history.map(function(m){ return m.content; }).join(' ') + ' ' + text;
    var orderMatch = text.match(/#?(\d{4,7})\b/i) || allText.match(/#?(\d{4,7})\b/i);
    var emailMatch = text.match(/[\w.-]+@[\w.-]+\.\w+/) || allText.match(/[\w.-]+@[\w.-]+\.\w+/);
    var storefrontContext = await getStorefrontContext();

    try {
      var res = await fetch(API, {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          message: text, history,
          orderNumber: orderMatch ? orderMatch[0] : undefined,
          orderEmail: emailMatch ? emailMatch[0] : undefined,
          sessionId, lang,
          pageUrl: window.location.href,
          pageTitle: (document.title||'').split(/\s*[|\u2013\u2014\u2012]\s*/)[0].trim(),
          storefrontContext: storefrontContext
        })
      });
      var data = await res.json();
      removeTyping();
      var reply = data.reply || 'Sorry, something went wrong. Email info@silverbackgymwear.com';
      addMessage('bot', reply);
      if (data.products && data.products.length > 0) addProductCards(data.products);
      // Handle navigation action
      if (data.navigate) {
        setTimeout(function() {
          var navBtn = document.createElement('div');
          navBtn.className = 'sb-msg sb-system';
          navBtn.style.cssText = 'margin-top: 8px;';
          navBtn.innerHTML = '<a href="' + data.navigate.url + '" target="_blank" rel="noopener" style="display:inline-block;background:#000;color:#fff;padding:10px 18px;border-radius:8px;text-decoration:none;font-weight:600;font-size:13px;">' + (isFr ? 'Aller à la page' : 'Go to page') + ' →</a>';
          var msgs = document.getElementById('sb-chat-messages');
          msgs.appendChild(navBtn);
          msgs.scrollTop = msgs.scrollHeight;
        }, 500);
      }
      history.push({role:'user',content:text});
      history.push({role:'assistant',content:reply});
      if (history.length > 20) history = history.slice(-20);
      saveState();
      // email form is user-triggered only — see #sb-contact-link
    } catch(e) {
      removeTyping();
      addMessage('bot', 'Connection issue — try again or email info@silverbackgymwear.com');
    }

    sending = false;
    document.getElementById('sb-chat-send').disabled = false;
    input.focus();
  }

  // ── Attention ring + badge (after 5s if not opened) ───────────────────────
  setTimeout(function() {
    if (!open) {
      bubble.classList.add('sb-ring');
      // Add unread badge
      if (!document.getElementById('sb-badge')) {
        var badge = document.createElement('div');
        badge.id = 'sb-badge'; badge.textContent = '1';
        bubble.appendChild(badge);
      }
      setTimeout(function() { bubble.classList.remove('sb-ring'); }, 2000);
    }
  }, 5000);

  // ── Init ─────────────────────────────────────────────────────────────────
  // iOS keyboard handling: pin the chat window to the *visual* viewport when open
  function isMobile() { return window.matchMedia && window.matchMedia('(max-width: 480px)').matches; }
  function syncToVisualViewport() {
    try {
      if (!isMobile() || !open || !window.visualViewport) return;
      win.style.height = window.visualViewport.height + 'px';
      win.style.top = window.visualViewport.offsetTop + 'px';
      win.style.bottom = 'auto';
      win.style.left = '0';
      win.style.right = '0';
    } catch(_) {}
  }
  function clearVisualViewportPin() {
    try {
      win.style.height = '';
      win.style.top = '';
      win.style.bottom = '';
      win.style.left = '';
      win.style.right = '';
    } catch(_) {}
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncToVisualViewport);
    window.visualViewport.addEventListener('scroll', syncToVisualViewport);
  }

  fetchMode();

  // ── Events ────────────────────────────────────────────────────────────────
  document.getElementById('sb-chat-input').addEventListener('input', function() {
    this.style.height = 'auto';
    this.style.height = Math.min(this.scrollHeight, 100) + 'px';
  });
  document.getElementById('sb-chat-input').addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
  });
  document.getElementById('sb-escalate-btn').addEventListener('click', escalate);
  document.getElementById('sb-email-submit').addEventListener('click', submitEmail);
  document.getElementById('sb-email-close').addEventListener('click', function() {
    document.getElementById('sb-email-bar').style.display = 'none';
  });
  document.getElementById('sb-email-addr').addEventListener('keydown', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); submitEmail(); }
  });
  document.getElementById('sb-email-addr').addEventListener('input', function() {
    this.style.borderColor = '';
  });
  document.getElementById('sb-contact-link').addEventListener('click', function() {
    var bar = document.getElementById('sb-email-bar');
    var visible = bar.style.display === 'block';
    bar.style.display = visible ? 'none' : 'block';
    setTimeout(function(){ syncToVisualViewport(); }, 50);
    if (!visible) {
      setTimeout(function(){
        document.getElementById('sb-email-name').focus();
        bar.scrollIntoView({ block: 'end', behavior: 'smooth' });
        syncToVisualViewport();
      }, 80);
    }
  });
  bubble.addEventListener('click', toggle);
  document.getElementById('sb-chat-close').addEventListener('click', toggle);
  document.getElementById('sb-chat-send').addEventListener('click', send);
})();
